import { Text } from '@oneaudi/unified-web-components';
import { ConfigurationSectionStyle } from '~/app/compositions/content/components/styles/section-style';

export function ConfigurationSection({
	children,
	title,
	description,
}: {
	children?: React.ReactNode;
	title: string;
	description?: string | null;
}) {
	return (
		<ConfigurationSectionStyle>
			<div className="section-container">
				<div className="title">
					<Text tag={'p'} variant={{ type: 'copy', order: '2', style: 'normal' }} className="lightgray">
						{title}
					</Text>
				</div>
				{description && (
					<Text tag={'p'} variant={{ type: 'copy', order: '2', style: 'normal' }} className={'alignRight'}>
						{description}
					</Text>
				)}
			</div>
			{children && <div className="children-container">{children}</div>}
		</ConfigurationSectionStyle>
	);
}
